import React from 'react';
export function Footer() {
  return <footer className="py-8 text-center bg-indigo-light text-cream/50 text-sm" data-id="element-84">
      <p data-id="element-85">© 2026 Cuentos Mágicos · Todos los derechos reservados</p>
    </footer>;
}